import { LinkIcon, FileCheckIcon, FranceMapIcon } from '@/components/ui/icons';
import { MOTION } from '@/utils';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { useRef } from 'react';

const REASSURANCE_ITEMS = [
  {
    title: '100% français',
    description: 'Solution développée en France, hébergée en France.',
    icon: FranceMapIcon,
  },
  {
    title: 'Connecté à Pennylane',
    description:
      'Synchronisation automatique des factures électroniques pour une gestion plus fluide.',
    icon: LinkIcon,
  },
  {
    title: 'Conforme 2026',
    description: 'Anticipez la réforme de la facturation électronique.',
    icon: FileCheckIcon,
  },
];

export default function ReassuranceSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<HTMLDivElement[]>([]);

  useGSAP(
    () => {
      if (!containerRef.current) return;
      const items = itemRefs.current.filter(Boolean);

      gsap
        .timeline({
          defaults: { duration: MOTION.durationMd, ease: MOTION.ease },
          scrollTrigger: {
            trigger: containerRef.current,
            start: 'top 70%',
            toggleActions: 'play none none reverse',
          },
        })
        .from(items, { autoAlpha: 0, y: MOTION.y, stagger: 0.1 });
    },
    { scope: containerRef },
  );

  return (
    <div ref={containerRef} className="w-full">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
        {REASSURANCE_ITEMS.map((item, index) => (
          <div
            key={item.title}
            ref={(el) => {
              if (el) itemRefs.current[index] = el;
            }}
            className="border-dark-blue/8 flex flex-col gap-3 rounded-(--radius-current) border bg-white p-6"
          >
            <div className="flex items-center gap-2">
              <div className="text-orange">
                <item.icon />
              </div>
              <span className="text-dark-blue font-roboto-medium text-sm">{item.title}</span>
            </div>
            <p className="text-dark-blue/55 text-sm! leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
